(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  document.addEventListener('click', (event) => {
    const dropdown = event.target.closest('[data-markets-dropdown]');
    const allDropdowns = document.querySelectorAll('[data-markets-dropdown]');

    allDropdowns.forEach((el) => {
      if (el !== dropdown) el.classList.remove('is-open');
    });

    if (!dropdown) return;

    const button = dropdown.querySelector('.markets-dropdown__trigger');
    dropdown.classList.toggle('is-open');
    button.setAttribute('aria-expanded', dropdown.classList.contains('is-open'));
  });

  } catch(e) { console.error(e); }
})();
})();
